import moment from 'moment-timezone';

/**
 * Day-level calculations — add / subtract N days, hop forward, snap to
 * start-of-day.
 */

export const addDaysInTimezone = (dateInput, days, timezone = moment.tz.guess()) => {
	const tz = typeof timezone === 'string' ? timezone : timezone?.value || moment.tz.guess();
	return moment(dateInput).tz(tz).add(days, 'days').startOf('day').toISOString();
};

export const subtractDaysInTimezone = (dateInput, days, timezone = moment.tz.guess()) => {
	const tz = typeof timezone === 'string' ? timezone : timezone?.value || moment.tz.guess();
	return moment(dateInput).tz(tz).subtract(days, 'days').startOf('day').toISOString();
};

export const getDayAfterDaysPeriod = (startDay, daysNumber) => {
	return moment(startDay).add(daysNumber, 'd');
};

export const getStarOfDay = (timestamp, timezone = moment.tz.guess()) => {
	return moment(timestamp).tz(timezone).startOf('day');
};

export const getStartOfDayInTimezone = (dateInput, timezone = moment.tz.guess()) => {
	const tz = typeof timezone === 'string' ? timezone : timezone?.value || moment.tz.guess();
	return moment(dateInput).tz(tz).startOf('day').toISOString();
};
